import { trustCards } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function TrustEntry() {
  return (
    <section id="verify" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          index="01"
          kicker="官方验证入口"
          title="从哪里进去，才不会被带到假站"
          desc="识别钓鱼网站的第一步，不是看页面好不好看，而是看入口对不对。下面三件事，决定你这一趟访问是安全的，还是踩进了钓鱼的坑。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {trustCards.map((card) => (
            <article
              key={card.title}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 md:p-7"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${card.icon} text-2xl`} />
                </span>
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-semibold tracking-wide text-secondary-900">
                  {card.tag}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 md:text-xl">{card.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                查看核对要点
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}